import styled from 'styled-components/macro';

export const PDFWrapper = styled.div`
    font-size: var(--text-sm);
    margin-left: var(--space-xxxxs);
`;
